import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import { persistStore } from 'redux-persist'

const updatedApplyMiddleware = applyMiddleware(thunk)
export const store = createStore(
    rootReducer,
    updatedApplyMiddleware
);

export const persistor = persistStore(store)
